<template>
    <div class="listmain ">
        <h1 class="firTitle">信息流</h1>
        <h3 class="sedTitle">控件接入</h3>

        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
       信息流的控件主要集成在OrionSpeakerHistoryView中，接入方需要在要接入的Activity的layout中添加代码(其实是一个不带标题的列表，接入时使其在标题下面即可)，然后在Activity的onCreate方法中进行试图绑定并调用。
          </span>
        </p>
        <highlight-code lang="javascript" v-html="">
            &lt;com.sdk.orion.lib.history.OrionSpeakerHistoryViewew
                    android:layout_width="match_parent"
                    android:layout_height="match_parent"/&gt;
        </highlight-code>
        <h3 class="sedTitle">控件使用</h3>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
       OrionSpeakerHistoryView 的调用需要注意以下public方法：<br>
|返回	|方法描述	| |------------	|:-----------------------	| | void | setOnOperateListener(OrionSpeakerHistoryView.OnOperateListener listener)<br>
实现控件的回调<br>
| | this | setIsUpdateData(boolean isUpdate, int updateDataTime)<br>
是否自动刷新数据, 默认false <br>
需在setOnOperateListener之后调用　| | this | setShowStatusInfo(boolean show)<br>
是否显示状态信息, 默认false <br>
需在setOnOperateListener之后调用　| | this | setShowCorrectGuide(boolean show)<br>
是否显示纠错引导, 默认false <br>
需在setOnOperateListener之后调用　|<br>
其中OrionSpeakerHistoryView.OnOperateListener是用户必须实现的接口，该接口主要包含的方法与操作示例如下（以mHistoryView表示OrionSpeakerHistoryView绑定的对象）：<br>
**onClickItem(int type, SpeakerHistory.History history)**在控件子项点击后的回调
          </span>
        </p>
        <highlight-code lang="javascript">
            @Override
            public boolean onClickItem(int type, SpeakerHistory.History history) {
                if(type == OrionSpeakerHistoryView.TYPE_YOURS) {
                //设置自己类型的事件
                    return true;
                }
                return false;
            }
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
              其中type的类型定义如下:
          </span>
        </p>
        <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
            <tbody>
            <tr>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    type值
                </td>
                <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    类型
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    OrionSpeakerHistoryView.TYPE_SMART_DEVICE
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    智能家居子项
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    OrionSpeakerHistoryView.TYPE_VOICE
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    播放音频子项
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    OrionSpeakerHistoryView.TYPE_VIDEO_PLAY
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    视频播放子项
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    OrionSpeakerHistoryView.TYPE_PAY
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    支付子项
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    OrionSpeakerHistoryView.TYPE_FEEDBACK_RESPONESE
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    回应子项
                </td>
            </tr>
            <tr>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    OrionSpeakerHistoryView.TYPE_FEEDBACK_RESPONSE
                </td>
                <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
                    反馈子项
                </td>
            </tr>
            </tbody>
        </table>

        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
      **onClickListInfo（int mode）**状态条不同类型的点击事件
          </span>
        </p>
        <highlight-code lang="javascript">
            @Override
            public void onClickListInfo(int mode) {
                switch (mode) {
                //静麦
                case ListInfoView.TYPE_MIC_CLOSE:
                //TODO 点击事件
                     break;
                //连接蓝牙
                case ListInfoView.TYPE_BLUETOOTH_OPEN:
                //TODO 点击事件
                    break;
                //未联网
                case ListInfoView.TYPE_WIFI_CLOSE:
                //TODO 点击事件
                   break;
                default:
                   break;
                }
            }
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
     **onLoadTop()**会在控件下拉到顶要拉取历史数据时被调
          </span>
        </p>
        <highlight-code lang="javascript">
            @Override
            public void onLoadTop() {
            SpeakerHistory speakerHistory = 异步获取到数据后;
            if(获取失败){
                mChatView.onTopLoadFail("拉取失败");
            }else{
                 mChatView.loadTopData(speakerHistory);
            }
            }
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
     **onLoadBottom()**会在控件下拉到底要获取最新数据时被调
          </span>
        </p>
        <highlight-code lang="javascript">
            @Override
            public void onLoadBottom() {
            SpeakerHistory speakerHistory = 异步获取到数据后;
            if(获取失败){
                 mHistoryView.onBottomLoadFail("拉取失败");
            }else{
                 mHistoryView.loadBottomData(speakerHistory);
            }
            }
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
     **onLoadInit()**会在控件初始化完成后，触发拉取初始数据
          </span>
        </p>
        <highlight-code lang="javascript">
            @Override
            public void onLoadInit() {
            SpeakerHistory speakerHistory = 异步获取到数据后;
            if(获取失败){
                 mHistoryView.onFirstLoadFail("拉取失败");
            }else{
                 mHistoryView.loadFirstData(speakerHistory);
            }
            }
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
    **onClickItem(int type, SpeakerHistory.OrderBean order)**在控件子项点击订单的回调(不用用户改写)
          </span>
        </p>
        <highlight-code lang="javascript">
            @Override
            public boolean onClickItem(int type, SpeakerHistory.OrderBean order) {
                return false;
            }
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
    最后还需要在Activity的生命周期方法中对OrionSpeakerHistoryView进行相应的处理。
          </span>
        </p>
        <highlight-code lang="javascript">
            @Override
            protected void onResume() {
                super.onResume();
                mHistoryView.onResume();
            }

            @Override
            protected void onDestroy() {
                mHistoryView.onDestroy();
                super.onDestroy();
            }
        </highlight-code>
    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-android/Info_flow_a.vue